import noop from 'lodash/noop';

import { APP_PLATFORM_EVENT_JSON_EVENT } from 'EventModels/app/platformBuilder';
import {
  createEventActionCreator,
  createEventTracker,
  createTrackerHook,
} from 'Store/sparks/tracker';

export type JsonEventData = {
  name: string;
  value: string;
};

export type TrackJsonEvent = (data: JsonEventData) => void;

export const jsonEventAction = createEventActionCreator<JsonEventData>({
  platformPayloadFn: ({ name, value }) => [
    {
      schema: APP_PLATFORM_EVENT_JSON_EVENT,
      name,
      value,
    },
    undefined,
  ],
});

export const IS_V3_INGESTION_MIGRATION_ENABLED =
  process.env.IS_V3_INGESTION_MIGRATION_ENABLED === 'true';

export const trackJsonEvent = IS_V3_INGESTION_MIGRATION_ENABLED
  ? createEventTracker<JsonEventData>(jsonEventAction)
  : (_: JsonEventData) => ({ type: 'noop' });
export const useTrackJsonEventEvent = IS_V3_INGESTION_MIGRATION_ENABLED
  ? createTrackerHook<JsonEventData>(jsonEventAction)
  : noop;
